export const publicRoutes = {
  home: "/",
  login: "/login",
  register: "/register",
  features: "/features",
  pricing: "/pricing",
  privacyPolicy: "/privacy-policy",
  terms: "/terms",
  externalTrade: "/external-trade",
  recurringTrade: "/recurring-trade",
  helpcenter: "/helpcenter",
  refer: "/ref",
  about: "/about",
  verify: "/verifyAccount",
  blog: "/blog",
  v2Waitlist: "/v2-waitlist",
  resetPassword: "/reset-password",
  requestAccountDeletion: "/request-account-deletion",
  confirmAccountDeletion: "/confirm-account-deletion",
};

export const adminRoutes = {
  dashboard: "/",
  logout: "/logout",
  login: "/login",
  register: "/register",
  users: "/users",
  addressVerificationReviews: "/address-verification-reviews",
  user: "/users/:id",
  merchants: "/merchants",
  transactions: "/transactions",
  balances: "/balances",
  rates: "/rates",
  cashback: "/cashback",
  referrals: "/referrals",
  creditUser: "/credit-user",
  analytics: "/analytics",
  deposits: "/deposits",
  explorer: "/explorer",
  testSms: "/test-sms",
  notifyAll: "/notify-all",
  paymentMerchant: "/payment-merchant",
  paymentOperations: "/payment-operations",
  btcBalance: "/btc-balance",
  bitoshiHour: "/bitoshi-hour",
  otcTransactions: "/otc-transactions",
  eddReviews: "/kyc/tier-3",
  kybReviews: "/kyc/tier-4",
  flaggedTransactions: "/flagged-transactions",
  withdrawalReviews: "/withdrawal-reviews",
  virtualCards: "/virtual-cards",
  settlements: "/settlements",
  gamification: "/gamification",
  assistant: "/assistant",
  accessControl: "/access-control",
  approvals: "/approvals",
  acceptInvitation: "/accept-invite",
  devices: "/devices",
};

export const vendorRoutes = {
  dashboard: "/",
  logout: "/logout",
  login: "/login",
  register: "/register",
  transactions: "/transactions",
  withdrawals: "/withdrawals",
  deposits: "/deposits",
  paymentMethods: "/payment-methods",
  profile: "/profile",
  withdraw: "/withdraw",
};

export const supportRoutes = {
  addressVerificationReviews: "/address-verification-reviews",
  dashboard: "/",
  logout: "/logout",
  login: "/login",
  register: "/register",
  users: "/users",
  user: "/users/:id",
  transactions: "/transactions",
  balances: "/balances",
  rates: "/rates",
  analytics: "/analytics",
  deposits: "/deposits",
  explorer: "/explorer",
};

export const paymentRoutes = {
  dashboard: "/",
};

export const subdomainRoutes = {
  default: "",
  www: "www",
  vendor: "merchant",
  admin: "admin",
  support: "support",
};
